import {Injectable, Query} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {UserService} from '@app/core';
import {Roles} from '../enums/roles.enum';
import {SelectItem} from "primeng/api";
import {CommonTransformationService} from "@app/shared/services/common-transformation.service";
import {FileService} from "@app/shared/services/file.service";
import {BLOB_RESPONSE_TYPE} from "../classes/common";
import {Transaction} from "../enums/txn-type.enum";
import {map} from "rxjs/operators";
import {QueryResult} from "@app/shared";

@Injectable()
export class RestrictedSolutionManagerService {
  /**
   * @desc  this service contains solution manager services that are restricted for shared services. all services here must use urlWithOrgId to set the url. urlWithOrgId()
   *        will ensure role check and set appropriate orgId before calling solution manager service.
   *        WARNING: NO other solution manager services call should be made from other than the Solution Manager module.
   */


  constructor(private http: HttpClient, private user: UserService, private transform: CommonTransformationService, private fileService: FileService) {
  }

  urlWithOrgId(url): string {
    let urlWithOrgId: string = url;

    if (this.user.isAuthorized([Roles.CSRAdmin]) || this.user.isAuthorized([Roles.OrgAdmin])) {
      urlWithOrgId += this.user.managingOrgId;
    } else {
      urlWithOrgId += this.user.info.orgId;
    }

    return urlWithOrgId;
  }

  urlWithBasedOnRole(url): string {
    let urlWithOrgId: string = url;
    if (this.user.isAuthorized([Roles.CSRAdmin]) || this.user.isAuthorized([Roles.OrgAdmin])) {
      urlWithOrgId = "/solution" + url + "&orgId=" + this.user.managingOrgId;
    }
    return urlWithOrgId;
  }

  checkAddrTypeAddrNameUniqueness(addressType: string, addressName: string): Observable<any> {
    let url = this.urlWithOrgId(`/solution/orgunits/addresses/unique?&addrType=${addressType}&addrName=${addressName}&orgId=`);
    return this.http.get<any>(url);
  }


  checkOrgMainContactUniqueness(): Observable<any> {
    let url = this.urlWithOrgId(`/solution/contacts/main/unique?orgId=`);
    return this.http.get<any>(url);
  }

  getMainAndOtherOrgAddress(): Observable<QueryResult> {
    let url = this.urlWithOrgId(`/solution/orgunits/addresses/main-and-other?orgId=`);
    return this.http.get<QueryResult>(url);
  }

  getMainAndOtherOrgAddressAsDropDown(): Observable<SelectItem[]> {
    return this.getMainAndOtherOrgAddress().pipe(map(res => {
      return this.transform.convertToDropDown("addrName", res.list, "id", true);
    }));
  }

  generateSampleCheck() {
    let url = this.urlWithOrgId(`/solution/orgunits/generate-sample-check?orgId=`);

    this.http.get(url, {observe: 'response', responseType: BLOB_RESPONSE_TYPE}).subscribe(data => {
      this.fileService.saveFileToLocalStorage("sample-check.pdf", data);
    });
  }

  getFileListForTransaction(txnType: Transaction | number, refId: number): Observable<QueryResult> {
    let url = `/folders/files?refId=${refId}&count=-1`;
    url = this.urlWithBasedOnRole(url);

    if (typeof txnType === "number") {
      url += `&transactionId=${txnType}`;
    } else {
      url += `&transaction=${txnType}`;
    }
    return this.http.get<QueryResult>(url);
  }

  saveFilesForTransaction(txnType: Transaction | number, refId: number, docFiles: any): Observable<any> {
    let url = `/folders/files?refId=${refId}`;
    url = this.urlWithBasedOnRole(url);
    if (typeof txnType === "number") {
      url += `&transactionId=${txnType}`;
    } else {
      url += `&transaction=${txnType}`;
    }
    return this.http.post(url, docFiles);
  }

}
